import { Pipe, PipeTransform } from '@angular/core';
import { CriterioDto, EscalaDto, UnidadMetaDto } from '../models';


@Pipe({ name: 'metaCriterios', standalone: false })
export class MetaCriteriosPipe implements PipeTransform {

    transform(value: UnidadMetaDto[], filter: number): CriterioDto[] {
        return value.find(um => um.id === filter)?.meta.criterios ?? [];
    }
}

@Pipe({ name: 'escalaCriterio', standalone: false })

export class EscalaCriterioPipe implements PipeTransform {

    transform(value: EscalaDto[], filter: number): EscalaDto {
        return value.find(e => e.id === filter);
    }
}

@Pipe({ name: 'unidadMetaCategoria', standalone: false })
export class UnidadMetaCategoriaPipe implements PipeTransform {

    transform(value: UnidadMetaDto[], filter: number): UnidadMetaDto[] {
        return value.filter(e => e.meta.categoriaId === filter);
    }
}
